document.addEventListener("DOMContentLoaded", function (event) {
  $(document).ready(function () {
    wrapMeta();
    checkBundles();

    document.body.addEventListener("docapp-discount-applied", (e) => {
      //console.log(JSON.stringify(e));
      climateText();
    });
  });

  // Add loader when remove is clicked
  // $('.cart__remove').click(function () {
  // 	$('.cart-loader').addClass('loading');
  // 	$('form.cart').addClass('loading');
  // });

  // Remove quantity of every bundled item, when main bundle item is removed
  // $('.bundles-remove').click(function (event) {
  // 	event.preventDefault();

  // 	var bundleId = $(this).attr('data-bundle-id');

  // 	$('.main-bundles-qty[data-bundle-id="' + bundleId + '"]').val(0);
  // 	$('.bundles-qty[data-bundle-id="' + bundleId + '"]').each(function () {
  // 		$(this).val(0);
  // 	});

  // 	$('form.cart').submit();
  // });

  async function removeItem(event) {
    event.preventDefault();

    const row = $(event.currentTarget).closest("tr[data-line_item_key]");
    const mainItemKey = row.attr("data-line_item_key");

    let updates = {
      [mainItemKey]: 0,
    };

    if (row.attr("data-bundle_id")) {
      // get bundle products line item key
      $(
        `form.cart tbody > .bundles-qty[data-bundle-id="${row.attr("data-bundle_id")}"]`
      ).each(function (_, x) {
        updates[$(x).attr("data-line_item_key")] = 0;
      });
    }

    try {
      $("body").addClass("loading");
      const response = await fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        }
      );
      const data = await response.json();
      console.log("Item(s) removed from cart.");
      // console.log("Response:", data);

      // update page without reload
      try {
        const htmlString = await (await fetch(`/cart`)).text();
        const parser = new DOMParser();
        const section = parser.parseFromString(htmlString, "text/html");

        let reloadSection = ".cart__footer";
        if (data.item_count == 0) {
          reloadSection = "#MainContent";
        }

        $(reloadSection).empty();
        $(section)
          .find(`${reloadSection} > *`)
          .each(function (_, x) {
            $(reloadSection).append(x);
          });

        // remove line item (& bundles if any)
        for (const lineItemKey in updates) {
          $(`form.cart tbody > [data-line_item_key="${lineItemKey}"]`).remove();
        }
        $("body").removeClass("loading");
        document.dispatchEvent(new CustomEvent("cart:updated"));
      } catch (error) {
        $("body").removeClass("loading");
        console.error("Failed to update page without reloading.");
        console.error(error);
      }
    } catch (error) {
      $("body").removeClass("loading");
      console.error("Failed to remove item(s) from cart.");
      console.error(error);
    }

    handleACDiscounts();
  }

  window.removeItemFromCartPage = removeItem;

  $(document).on("click", ".cart__remove", function (event) {
    removeItem(event);
  });

  // Updating quantity of every bundled item, when main bundle item quantity changes
  $(".main-bundles-qty").change(function () {
    var bundleId = $(this).attr("data-bundle-id");
    var value = $(this).val();
    var Perv_value = $(this).attr("data-old-qty");
    $('.bundles-qty[data-bundle-id="' + bundleId + '"]').each(function () {
      var cValue = $(this).val();
      var aQty = parseInt(cValue) / parseInt(Perv_value);
      var Qty = parseInt(aQty) * parseInt(value);
      $(this).val(Qty);
    });
    $(this).attr("data-old-qty", value);
  });

  function checkBundles() {
    var flag = false;
    $(".bundles-qty").each(function () {
      var bundleId = $(this).attr("data-bundle-id");
      if (
        $('.main-bundles-qty[data-bundle-id="' + bundleId + '"]').length == 0
      ) {
        $(this).val(0);
        flag = true;
      }
    });
    if (flag) $("form.cart").submit();
  }

  function wrapMeta() {
    // not the subscription plan line ("First payment $x, then $y ..."), whose comma is text
    $(".cart__meta-text:not(.cart__selling-plan)").each(function () {
      var metaText = $(this).html().replaceAll(",", "<br>");
      $(this).html(metaText);
    });
  }

  function climateText() {
    $(
      ".docapp-cart-item.docapp-cart-discount.docapp-clearfix .docapp-left"
    ).each(function () {
      var yada = $(this).text().trim();
      if (yada == "CLIMATE400") {
        var yada2 = $(this).next().text().trim().replace("-", "");
        $(".upto-amt").text(yada2);
      } else if (yada == "Discount") {
        var yada2 = $(this)
          .next()
          .find(".money")
          .text()
          .trim()
          .replace("-", "");
        $(".upto-amt").text(yada2);
      }
    });
  }

  async function getCartData() {
    return await (await fetch("/cart.js")).json();
  }

  async function handleACDiscounts() {
    // remove all ac codes, then add new one after checking
    window.discountOnCartProApp.removeCodes([
      "SAVER1050",
      "SAVER800",
      "SAVER400",
      "SAVER50",
      "FREE700",
      "FREE550",
      "MULTI1200",
      "MULTI1050",
      "MULTI900",
      "FREE700",
      "FREE550",
      "FREE400",
      // "SERVICINGVOUCHER",
      // "MULTISERVICINGVOUCHER"
    ]);

    const cartData = await getCartData();

    const aircons = cartData.items.filter((x) =>
      [8841655419107, 8846508818659].includes(x.product_id)
    );
    if (!aircons.length) return;

    const isMultiSystem = checkIsMultiSystem(aircons);
    const hasStandardBundle =
      aircons.filter((x) => x.properties._acBundle == "standard").length > 0;
    const largestSystem = getACLargestSystem(aircons);
    if (!largestSystem) return;

    let newCode = null;

    let type = "";
    if (!isMultiSystem && !hasStandardBundle) type = "singleSaver";
    if (!isMultiSystem && hasStandardBundle) type = "singleStandard";
    if (isMultiSystem && !hasStandardBundle) type = "multiSaver";
    if (isMultiSystem && hasStandardBundle) type = "multiStandard";

    switch (type) {
      case "singleSaver":
        if (largestSystem == 4) newCode = "SAVER1050";
        if (largestSystem == 3) newCode = "SAVER800";
        if (largestSystem == 2) newCode = "SAVER400";
        if (largestSystem == 1) newCode = "SAVER50";
        break;

      case "singleStandard":
        if (largestSystem == 4) newCode = "FREE700";
        if (largestSystem == 3) newCode = "FREE550";
        break;

      case "multiSaver":
        if (largestSystem == 4) newCode = "MULTI1200";
        if (largestSystem == 3) newCode = "MULTI1050";
        if (largestSystem == 2) newCode = "MULTI900";
        break;

      case "multiStandard":
        if (largestSystem == 4) newCode = "FREE700";
        if (largestSystem == 3) newCode = "FREE550";
        if (largestSystem == 2) newCode = "FREE400";
        break;

      default:
        break;
    }

    if (newCode) {
      window.discountOnCartProApp.applyCode(newCode);

      // let servicingCode = type.includes("single") ? "SERVICINGVOUCHER" : "MULTISERVICINGVOUCHER";

      // let servicingApplied = false;
      // if (servicingCode) {
      //   document.body.addEventListener('docapp-discount-applied', (e) => {
      //     const hasNewCode = e.discounts.find((x) => x.title == newCode) != null;
      //     const hasServicingCode = e.discounts.find((x) => x.title == servicingCode) != null;
          
      //     if (hasServicingCode) {
      //       servicingApplied = true;
      //     }
      //     if (!servicingApplied && hasNewCode && !hasServicingCode) {
      //       window.discountOnCartProApp.applyCode(servicingCode);
      //     }
      //   });
      // }
    }
  }

  function checkIsMultiSystem(aircons) {
    let result = false;
    let count = 0;

    if (aircons.length > 1) {
      aircons.forEach((x) => {
        const name = x.variant_title.split("-")[0].trim();
        const size = name.split(" ")[1];
        if (size > 1) count++;
      });
    }

    result = count > 1;

    return result;
  }

  function getACLargestSystem(aircons) {
    let largest = 0;

    aircons.forEach((x) => {
      const name = x.variant_title.split("-")[0].trim();
      const size = name.split(" ")[1];
      if (size > largest) largest = size;
    });

    return largest;
  }

  function runWhenDrDiscountReady(callback) {
    const checkInterval = setInterval(() => {
      if (window.discountOnCartProApp != null) {
        clearInterval(checkInterval);
        callback();
      }
    }, 200); // check every 200ms
  }

  runWhenDrDiscountReady(handleACDiscounts);
});

/* to total the price of auto bundled items like in evosonic */
document.addEventListener("DOMContentLoaded", function () {
  // Loop through each cart line
  document.querySelectorAll(".cart__row").forEach(function (row) {
    // Find any cart__meta-text that contains "Selected"
    const selectedLine = Array.from(row.querySelectorAll(".cart__meta-text"))
      .find(el => el.textContent.toLowerCase().includes("selected"));

    if (!selectedLine) return; // no "Selected" line → skip

    // Extract the bundle add-on price inside parentheses
    const match = selectedLine.textContent.match(/\(\$?([\d,.]+)/); // e.g. "($99)"
    if (!match) return;

    const addonPrice = parseFloat(match[1].replace(/,/g, ""));
    if (isNaN(addonPrice) || addonPrice <= 0) return;

    // Find price span (only the actual price)
    //const priceEls = row.querySelectorAll(".lastColumn .line-price-custom");

    priceEls.forEach(function (priceEl) {
      // Extract base price number
      const baseText = priceEl.textContent.replace(/[^0-9.,]/g, "");
      const basePrice = parseFloat(baseText.replace(/,/g, "")) || 0;

      // Compute new total
      const newTotal = basePrice + addonPrice;

      // Detect and preserve currency symbol
      const currencySymbol = priceEl.textContent.trim().charAt(0) === "$" ? "$" : "$";

      // Update only the visible price span (not the buttons)
      priceEl.textContent = `${currencySymbol}${newTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
    });
  });
});

function lockZeroPriceQty() {

  // subscriptions can be $0 on the first order (Seal) but keep their quantity
  $(".cart__row[data-product-price='0']:not(.cart__row--subscription)").each(function () {

    const $row = $(this);

    // disable input
    $row.find(".cart__qty-input").prop("disabled", true);

    // block +/- clicks
    $row.find(".qtyBtn").on("click", function(e){
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

  });

}

$(document).ready(function () {
  lockZeroPriceQty();
});

/* hide quantity if price is zero */
$(document).ready(function () {

  $('tr.cart__row:not(.cart__row--subscription)').each(function () {

    const priceText = $(this)
      .find('.line-price-custom')
      .text()
      .trim();

    if (priceText === '$0.00') {

      $(this).find(
        '.cart__qty, .cart__qty-label, .cart__update'
      ).hide();

    }

  });

});
/* end of hide quantity */

/* update price display when qty is clicked */
function updateCartRowPrice(row) {
  const qtyInput = row.querySelector(".cart__qty-input");
  const priceEl = row.querySelector(".line-price-custom");

  if (!qtyInput || !priceEl) return;

  const unitPrice = parseInt(row.dataset.unitPrice, 10) || 0;
  const quantity = parseInt(qtyInput.value, 10) || 0;

  const linePrice = unitPrice * quantity;

  const formatMoney = cents => `$${(cents / 100).toLocaleString("en-SG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;

  priceEl.textContent = formatMoney(linePrice);

  // subscription line: "First payment $x, then $y every N months" (cart-line-item.liquid)
  const planPriceEl = row.querySelector(".cart__selling-plan-price");

  if (planPriceEl) {
    const firstPrice = parseInt(planPriceEl.dataset.firstPrice, 10) || 0;
    const recurringPrice = parseInt(planPriceEl.dataset.recurringPrice, 10) || 0;
    const months = parseInt(planPriceEl.dataset.months, 10) || 0;
    const interval = months ? `every ${months} ${months === 1 ? "month" : "months"}` : "per delivery";

    planPriceEl.textContent =
      `First payment ${formatMoney(firstPrice * quantity)}, then ${formatMoney(recurringPrice * quantity)} ${interval}`;
  }
}


// +/- buttons
$(document).on("click", ".cartQtyBox .qtyBtn", function () {
  const row = this.closest(".cart__row");

  // Let the existing +/- script update the input first
  setTimeout(function () {
    updateCartRowPrice(row);
  }, 0);
});


// Manual quantity input
$(document).on("input change", ".cart__qty-input", function () {
  const row = this.closest(".cart__row");

  updateCartRowPrice(row);
});